import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomerAction, useModal } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Button, Modal } from "@gemini/ui";
import { EnergyCost, EnergyFeatures } from "@/components/Sections/Energy";
import { Fragment } from "react";
import { useEnergy } from "../.";
import { Certificate } from "../Certificate";
import { useTrackingShowMore } from "@/hooks/tracking/useTrackingShowMore";
import { InteractionEnum } from "@/types";
import { ModalIds } from "@/constants";
export const EnergyModal = ({ testId }) => {
    const { t } = useI18n();
    const { certificates, features } = useEnergy();
    const title = t("energy.title");
    const { isOpen, open, toggle } = useModal(false, ModalIds.ENERGY);
    const { customerActionLeadInteraction } = useCustomerAction();
    const handleTrackingShowMore = useTrackingShowMore("classified_energy_details");
    const trackCustomerActionSectionReadMore = (title) => {
        customerActionLeadInteraction(InteractionEnum.OPEN_MORE, title);
        handleTrackingShowMore();
    };
    return (_jsxs(_Fragment, { children: [(certificates === null || certificates === void 0 ? void 0 : certificates.length) > 0 && (_jsx(Box, { unsafe_className: "HideOnPrint", children: _jsx(Button, { variant: "secondary", isFullWidth: {
                        "breakpoint.base": true,
                        "breakpoint.sm": false,
                    }, testId: `${testId}-button`, onPress: () => {
                        trackCustomerActionSectionReadMore(title);
                        open();
                    }, children: t("cta.show_details") }) })), _jsxs(Modal, { testId: testId, title: title, titleAs: "h2", isDismissable: true, trigger: () => null, isOpen: isOpen, onOpenChange: toggle, children: [certificates === null || certificates === void 0 ? void 0 : certificates.map((certificate, index, arr) => (_jsxs(Fragment, { children: [_jsx(EnergyCost, { certificate: certificate }), _jsx(Certificate, { certificate: certificate, variant: "fullsize", isLast: index === arr.length - 1, testId: `${testId}-certificate` })] }, certificate.key))), _jsx(Box, { paddingBottom: "spacing.16", children: _jsx(EnergyFeatures, { features: features, rootTestId: `${testId}.Features`, variant: "fullsize", showDivider: !!certificates }) })] })] }));
};
